import React, { useEffect, useState } from "react";
import "../microsite/microsite.css";
import "../../css/emailTemplate.css";

import {useActiveCompanyData} from "hooks/CompanyHooks";
import { getCustomerEmailTemplates, saveCustomerEmailTemplate } from "apiService/RESTApi";
import {Spin, message, Divider, Row} from "antd";
import WebchatEmailTemplateTabMenu from "../../Components/Webchat/WebchatEmailTemplateTabMenu";
import WebchatEmailTemplateEditor from "../../Components/Webchat/WebchatEmailTemplateEditor";
import {
    emailTemplatesFetchedFromServer,
    emailTemplatesInitialFetchCompleted
} from "store/actions/WebchatEmailTemplateAction";
import {useDispatch, useSelector} from "react-redux";
import WebchatTabs from "../../Components/Webchat/WebchatTabs";

import BlockNavWithUnsavedChangesModal from "./../../Components/Navigation/BlockNavWithUnsavedChangesModal.js"
import WebchatSaveButton from "../../Components/Webchat/WebchatSaveButton";
import SkeletonBlock from "./../../commons/SkeletonBlock.js";

export default function CustomerEmailTemplate() {

    const dispatch = useDispatch();
    const activeCompanyData = useActiveCompanyData();

    const [isPageLoading, setIsPageLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const {unmodifiedEmailTemplates, editor} = useSelector((state) => state.WebchatEmailTemplateReducer);
    const [hasUnsavedChanges, setUnsavedChanges] = useState(false);

    const saveChanges = async () => {
        setIsSaving(true);
        const changesToSave = editor;
        try {
            const payload = {
                customerUuid: activeCompanyData.uuid,
                templateId: changesToSave.id,
                name: changesToSave.name,
                subject: changesToSave.subject,
                body: changesToSave.body,
            };

            let saveCustomerEmailTemplateResponse = await saveCustomerEmailTemplate(payload);

            // TODO RESPONSE SHOULD BE THE UPDATED OBJECT (currently the template id)
            if (saveCustomerEmailTemplateResponse && saveCustomerEmailTemplateResponse.id === changesToSave.id) {

                // FETCH DATA AGAIN SINCE THE SERVER RESPONSE IS NOT THE UPDATED OBJECT
                // dispatch(emailTemplateSavedToServer(saveCustomerEmailTemplateResponse));
                const fetchedTemplatesResponse = await getCustomerEmailTemplates(activeCompanyData.uuid);
                dispatch(emailTemplatesFetchedFromServer(fetchedTemplatesResponse));
                console.log("Templates fetched from server!");

                console.log(`${payload.name} template updated successfully`);
                message.success("Template Saved!");
                setUnsavedChanges(false);
            } else {
                console.error(`Failed to save ${changesToSave.type}`);
                message.error(`Failed to save template`);
            }

        } catch (error) {
            console.error(`Error saving ${changesToSave} template:`, error);
            message.error(`Error saving template`);
        }

        setIsSaving(false);
    }

    // Check for unsaved changes
    useEffect(() => {
        const checkUnsavedChanges = () => {
            if (!editor || !unmodifiedEmailTemplates) {
                setUnsavedChanges(false);
                return;
            }

            const unmodifiedTemplate = unmodifiedEmailTemplates[editor?.id];

            // Check if all key-value pairs are the same
            const unmodifiedKeys = Object.keys(unmodifiedTemplate || {});
            const hasDifferences = unmodifiedKeys.some(key => {
                return !editor.hasOwnProperty(key) || unmodifiedTemplate[key] !== editor[key];
            });
            setUnsavedChanges(hasDifferences);
        };

        checkUnsavedChanges();
    }, [unmodifiedEmailTemplates, editor]);

    // On Page Load
    useEffect(() => {
        const fetchCustomerEmailTemplates = async () => {
            setIsPageLoading(true);
            if (!activeCompanyData.uuid) {
                // When page is hydrating activeCompanyData may not be available
                return;
            }

            try {
                const fetchedTemplatesResponse = await getCustomerEmailTemplates(activeCompanyData.uuid);
                dispatch(emailTemplatesFetchedFromServer(fetchedTemplatesResponse));
                console.log("Templates fetched successfully from server!");
                dispatch(emailTemplatesInitialFetchCompleted());

            } catch (error) {
                console.error("Error fetching templates:", error);
            }
            setIsPageLoading(false);
        };

        fetchCustomerEmailTemplates();
    }, [activeCompanyData.uuid, dispatch]);

    return (
        <div id="webchat-emailtemplate-page" className="webchat-page">
            <BlockNavWithUnsavedChangesModal hasUnsavedChanges={hasUnsavedChanges}/>
            {/* Header Section */}
            <div className="editor-header">
                <div className="editor-header-left">
                    <h2><strong>ChatStream</strong></h2>
                    <p className="subheading">Easily connect with your contacts in a web-based, mobile-enabled
                        channel.</p>
                </div>
                <div className="editor-header-right">
                    <div className="editor-header-right">
                        <WebchatSaveButton hasUnsavedChanges={hasUnsavedChanges} onSaveCallback={saveChanges}/>
                    </div>
                    <button className="preview-button" hidden={true}>Preview</button>
                </div>
            </div>
            <Divider style={{marginTop: '20px'}}/>
            <Spin spinning={isPageLoading || isSaving} tip={`${isSaving ? "Saving" : "Loading"} templates...`}
                  size="medium">
                <div className="main-container">
                    {/* Editor Section */}
                    <div className="editor-main-container">
                        {
                            isPageLoading ? (
                                <div style={{background: "#fff", padding: 20}}>
                                    <Row justify="center" gutter={[20, 20]}>
                                        <SkeletonBlock style={{width: 800, height: 500}}/>
                                    </Row>
                                </div>
                            ) : (
                                <WebchatEmailTemplateEditor/>
                            )
                        }
                    </div>

                    {/* Right Menu */}
                    <div className="templates-list-header-container ant-tabs-nav-wrap">
                        {
                            isPageLoading ? (
                                <div style={{background: "#fff", padding: 20}}>
                                    <Row justify="center" gutter={[20, 20]}>
                                        <SkeletonBlock style={{width: 375, height: 500}}/>
                                    </Row>
                                </div>
                            ) : (
                                <>
                                    {/* Tabs Header */}
                                    <WebchatTabs/>
                                    { /* Tab Content */}
                                    <div className="template-list-container">
                                        <WebchatEmailTemplateTabMenu/>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            </Spin>
        </div>
    );
}
